import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api.js';

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 10_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: true,
        retry: (failureCount, error) => {
          // Client errors (4xx) will not fix themselves, and 501 means the API
          // module is not built in this image; retry only real server/network
          // failures, and only a couple of times.
          if (error instanceof ApiError && (error.status < 500 || error.status === 501)) {
            return false;
          }
          return failureCount < 2;
        },
      },
      mutations: {
        retry: false,
      },
    },
  });
}
